const url = (import.meta.env.VITE_SUPABASE_URL ?? '').replace(/\/$/, '');

export const config = {
  supabaseUrl: url,
  /** publishable (anon) key — safe for the browser; all access is enforced by RLS/RPC checks */
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  functionsUrl: (import.meta.env.VITE_FUNCTIONS_URL ?? (url ? `${url}/functions/v1` : '')).replace(/\/$/, ''),
};

export const isConfigured = Boolean(config.supabaseUrl && config.supabaseAnonKey);
